export interface IClinicApp {
  id: string;
  name: string;
  app_key: string;
  scopes: string[];
  is_active: boolean;
  created_at: string;
  last_used_at: string | null;
}

export interface IClinicAppCreated extends IClinicApp {
  app_secret: string;
}

export interface ICreateClinicAppRequest {
  name: string;
  scopes: string[];
}

export interface IUpdateClinicAppScopesRequest {
  scopes: string[];
}

export const AVAILABLE_SCOPES = [
  { value: 'sales:read', label: 'Vendas (leitura)' },
  { value: 'patients:read', label: 'Pacientes (leitura)' },
  { value: 'anamnesis:read', label: 'Anamnese (leitura)' },
];
